<template>
  <div class="app-main-content tab-vessel">
    <div class="grid-view">
      <div
        v-show="showMainList"
        class="main-content"
        type="primary"
      >
        <div style="width:100%; height: 100%; overflow:hidden">
          <div class="section" style="float:left; height: 100%; width:25.5%;">
            <el-form :disabled="!isEdit" label-width="75px" label-position="left" style="height: 100%; min-width: 250px">
              <el-card class="form-card section" style="height: 100%;">
                <fieldset style="border: none">
                  <el-form-item :label="$t('CargoMsg.Cargo_ChineseNamed')">
                    <el-input
                      v-model="vessel.chineseName"
                      no="1"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_EnglishNamed') }}</span>
                    <el-input
                      v-model="vessel.englishName"
                      no="2"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" class="blue">{{ $t('SeaExport.OperateCarrier') }}</span>
                    <cargo-company-select
                      :method-params="{seaCmp:true,active:true}"
                      :default-value="vessel.carrierId||''"
                      no="3"
                      @change="p=>{vessel.carrierId=p.value}"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CountryOfRegistration')">
                    <cargo-advance-select
                      :select-type="selectTypeNames.basic_data_Country"
                      :tag-name="isZh ? 'chineseName' : 'name'"
                      tag-value="code"
                      filterable
                      :filter-tag-names="['chineseName', 'name', 'code']"
                      :default-value="vessel.regCountry||''"
                      no="4"
                      @parentCallBack="p=>{vessel.regCountry=p.value}"
                    />
                  </el-form-item>
                  <el-form-item label="IMO">
                    <el-input
                      v-model="vessel.imoCode"
                      no="5"
                    />
                  </el-form-item>
                  <el-form-item label="MMSI">
                    <el-input
                      v-model="vessel.mmsiCode"
                      no="6"
                    />
                  </el-form-item>
                  <el-form-item label="CallSign">
                    <el-input
                      v-model="vessel.callSign"
                      no="7"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model="vessel.importVoyage" style="word-break: break-all; white-space: normal;" no="8">{{ $t('SeaExport.AutomaticallyImportVoyage') }}</el-checkbox>
                  </el-form-item>
                  <el-form-item style="height: 100%" :label="$t('SeaExport.VSACarrier')">
                    <div class="main-content">
                      <div class="section grid-wrapper" style="min-height: 260px">
                        <cargo-ag-grid
                          :grid-params.sync="carrierGrid.gridParams"
                          :grid-options="carrierGrid.gridOptions"
                          :column-defs="carrierColumnDefs"
                          :show-side-bar="false"
                          :row-data="carrierGrid.rowData"
                        />
                        <div style="margin: 0; padding: 0; width: 100%">
                          <div style="margin: 10px 5px">
                            <el-button style="width: 150px;word-break: break-all; white-space: normal;" type="primary" no="9" @click="onCarrierAdd">
                              {{ $t('SeaExport.AddShippingCompany') }}
                            </el-button>
                            <el-button :disabled="!carrierGrid.selectedRow" style="margin-left: 5px; width: 145px;word-break: break-all; white-space: normal;" type="danger" no="10" @click="onCarrierRemove">
                              {{ $t('SeaExport.DelShippingCompany') }}
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </fieldset>
              </el-card>
            </el-form>
          </div>
          <div class="main-content" style="float:right; height: 100%; width:74%;">
            <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search">
              <div class="section cargo-advance-search-more">
                <el-form
                  label-position="left"
                  class="cargo-advance-search-form"
                  label-width="100px"
                  style="min-width: 830px;margin-right: 10px;"
                  :inline="true"
                >
                  <el-form-item :label="$t('Partners.search')">
                    <el-input v-model="searchValue" style="flex: 1" :disabled="isEdit" no="11" @input="selectedBak = [...selectedData]" />
                  </el-form-item>
                  <el-button :style="{marginLeft: '10px', width: $selectByLang('60px', '60px', '60px', '120px', '120px', '120px')}" type="primary" no="12" @click="onAddSave">
                    {{ isEdit ? $t('SeaExport.Save') : $t('SeaExport.Add') }}
                  </el-button>
                  <el-button :style="{marginLeft: '10px', width: $selectByLang('60px', '60px', '60px', '120px', '120px', '120px')}" type="primary" :disabled="!hasChooseVessel && !isEdit" no="13" @click="onEditCancel">
                    {{ isEdit ? $t('SeaExport.Cancel') : $t('SeaExport.Edit') }}
                  </el-button>
                  <el-button style="margin-left: 10px; width: 60px" type="danger" :disabled="!hasChooseVessel || isEdit" no="14" @click="onRemove">
                    {{ $t('SeaExport.Delete') }}
                  </el-button>
                  <el-button :style="{marginLeft: '10px', width: $selectByLang('60px', '60px', '60px', '120px', '120px', '120px')}" type="primary" no="15" @click="vesselImport">
                    {{ $t('SeaExport.MSCVesselImport') }}
                  </el-button>
                  <el-button style="margin-left: 10px; width: 120px" type="primary" no="16" @click="mscEdiExport">
                    {{ $t('SeaExport.MSCEDIExport') }}
                  </el-button>
                  <el-button style="margin-left: 10px" type="primary" no="17" @click="downloadTemplate">
                    {{ $t('SeaExport.TemplateDownload') }}
                  </el-button>
                  <el-upload
                    ref="vesselUpload"
                    :action="URL.mdm.importVessel"
                    :headers="{sessionId}"
                    :show-file-list="false"
                    accept=".xls, .xlsx"
                    :on-success="uploadExcelSuccess"
                    :data="{branchId:$store.getters.currentOfficeId}"
                    style="display: inline-block; margin-left: 10px;"
                    no="18"
                  >
                    <el-button type="primary" no="19">{{ $t('SeaExport.import') }}</el-button>
                  </el-upload>
                  <el-button style="margin-left: 10px" type="primary" no="20" @click="importVesselResultLog">
                    {{ $t('SeaExport.ImportResultLog') }}
                  </el-button>
                </el-form>
              </div>
            </div>
            <div :disabled="isEdit" class="section grid-wrapper">
              <cargo-ag-grid
                :grid-params.sync="vesselGrid.gridParams"
                :grid-options="vesselGrid.gridOptions"
                :column-defs="vesselColumnDefs"
                :show-side-bar="false"
                :row-data="filterData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <import-result
      :visible="importResultDialog.visible"
      :result="importResultDialog.result"
      @continueImporting="continueImporting"
      @close="closeImportResultDialog"
    />
    <el-dialog
      v-el-drag-dialog
      :visible.sync="mscImportDialog.visible"
      :title="$t('SeaExport.MSCVesselImport')"
      width="500px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      class="main-content"
    >
      <div class="section" style="text-align: center; width: 100%">
        <el-form
          label-position="left"
          label-width="60px"
          style="width: 100%; vertical-align: middle;"
          :inline="true"
        >
          <el-form-item :label="$t('SeaExport.ShippingCompany')">
            <cargo-company-select
              :method-params="{seaCmp:true,active:true}"
              custom-style="width: 190px"
              :default-value="mscImportDialog.carrierId||''"
              no="21"
              @change="p=>{mscImportDialog.carrierId=p.value}"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-upload
          ref="upload"
          :action="URL.mdm.bulkInsertsVessel"
          :headers="{sessionId}"
          :show-file-list="false"
          :on-success="uploadExcelSuccess"
          :data="{carrierId:mscImportDialog.carrierId}"
          style="display: inline-block; margin-left: 10px;"
          no="22"
        >
          <el-button type="primary" no="23">{{ $t('SeaExport.UploadFile') }}</el-button>
        </el-upload>
      </div>
    </el-dialog>
    <edi-popup
      ref="ediPopup"
      :visible.sync="ediPopup.visible"
      title="MSC EDI"
      :template-type="28"
      @ok="getEDI"
      @close="onEdiPopupClose"
    />
    <edi-of-vessel-dialog
      ref="ediOfVessel"
      :visible.sync="ediOfVessel.visible"
      @close="onEdiOfVesselClose"
    />
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getVesselList, saveVessel, delVessel } from '@/api/vessel'
import { queryLastFileDocumentId } from '@/api/seaExport/businessDocument'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor/index'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import ImportResult from '@/views/cargo/v0/SeaExport/Vessel/components/importResult'
import URL from '@/api/urlTranslator'
import { cache } from '@/utils/cacheManager'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { Vessel } from '@/class/model/mdm/Vessel'
import EdiPopup from '@/components/Cargo/Common/EdiPopup'
import { getVesselEDI } from '@/api/seaExport/edi'
import EdiOfVesselDialog from '@/views/cargo/v0/SeaExport/Vessel/components/EdiOfVesselDialog'

export default {
  name: 'TabVessel',
  components: { EdiOfVesselDialog, EdiPopup, CargoCompanySelect, ImportResult, CargoAdvanceSelect },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      searchValue: '',
      selectedBak: [],
      selectedData: [],
      isZh: this.$store.getters.language === 'zh',
      storageURL: '',
      vessel: {},
      showDetail: false,
      segmentMap: {}, // 航次明细缓存
      delCarrierRows: [], // 删除的数据缓存
      importResultDialog: {
        visible: false,
        result: {}
      },
      mscImportDialog: {
        visible: false,
        carrierId: 0
      },
      ediPopup: {
        visible: false
      },
      ediOfVessel: {
        visible: false
      },
      carrierGrid: {
        gridParams: {},
        gridOptions: {
          suppressCellSelection: true,
          rowSelection: 'single',
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          },
          onRowClicked: this.onCarrierGridRowClickedEvent
        },
        rowData: [],
        selectedRow: null, // 单击选中的行数据
        selectedIndex: -1
      },
      vesselGrid: {
        gridParams: {},
        gridOptions: {
          suppressCellSelection: true,
          rowSelection: 'single',
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridDateTimeEditor
          },
          // 单击显示编辑
          singleClickEdit: true,
          onRowClicked: this.onVesselGridRowClickedEvent
        },
        rowData: [],
        selectedRow: null,
        selectedIndex: -1
      },
      isEdit: false,
      isAdd: false,
      fullscreenLoading: null,
      filter: {
        pageNum: 1,
        pageSize: 50,
        total: 0
      },
      carrierColumnDefs: [
        {
          headerName: this.$t('SeaExport.ShippingCompany'), field: 'carrierId', colId: 'carrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, this.language)
          },
          editable: () => { return this.isEdit },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagName: this.language,
              tagValue: 'cmpIdx',
              methodParams: { active: true, seaCmp: true },
              filterable: true,
              clearable: true
            }
          }
        },
        {
          headerName: this.$t('SeaExport.EDICode'), field: 'edicode', colId: 'edicode', width: 200,
          editable: () => { return this.isEdit },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }
      ],
      vesselColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseNamed'), field: 'chineseName', colId: 'chineseName', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishNamed'), field: 'englishName', colId: 'englishName', width: 100
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'), field: 'carrierId', colId: 'carrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, this.language)
          }
        },
        {
          headerName: this.$t('SeaExport.CountryOfRegistration'), field: 'regCountry', colId: 'regCountry', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, 'name')
          }
        },
        {
          headerName: 'IMO', field: 'imoCode', colId: 'imoCode', width: 100
        },
        {
          headerName: 'MMSI', field: 'mmsiCode', colId: 'mmsiCode', width: 100
        },
        {
          headerName: 'CallSign', field: 'callSign', colId: 'callSign', width: 100
        },
        {
          headerName: this.$t('SeaExport.AutomaticallyImportVoyage'), field: 'importVoyage', colId: 'importVoyage', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    },
    sessionId() {
      return this.$store.getters.token
    },
    filterData() {
      const { searchValue } = this
      const rowData = this.vesselGrid.rowData
      if (!searchValue.trim()) {
        return rowData
      } else {
        const filterKeys = ['vesselId', 'chineseName', 'englishName']
        return rowData.filter(row => {
          for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i]
            if (row[key] && String(row[key]).toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) return true
          }
        })
      }
    },
    hasChooseVessel() {
      return this.vesselGrid.selectedIndex >= 0
    }
  },
  watch: {
    filterData() {
      this.$nextTick(() => {
        this.selectedData = [...this.selectedBak]
      })
    }
  },
  created() {
    this.toQuery()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.storageURL = cache.config.get('StorageURL')
    },
    onAddSave() {
      if (this.isEdit) {
        this.onSave()
        return
      }
      this.onAdd()
    },
    onAdd() {
      this.isEdit = true
      this.isAdd = true
      this.vessel = { vesselCarriers: [] }
      this.carrierGrid.rowData = this.vessel.vesselCarriers
    },
    onSave() {
      const { vessel } = this
      vessel.vesselCarriers = this.carrierGrid.rowData
      if (this.isAdd || this.isEdit) {
        for (const carrier of vessel.vesselCarriers) {
          if (!carrier.carrierId || carrier.carrierId < 1) {
            this.$message.warning(this.$t('SeaExport.pleaseDelEmptyCarrierRecord'))
            return
          }
          if (carrier.carrierId === vessel.carrierId) {
            this.$message.warning(this.$t('SeaExport.CannotBeTheSame'))
            return
          }
        }
      }
      if (StrUtils.isEmpty(vessel.englishName)) {
        this.$message.warning(this.$t('SeaExport.EnglishShipNameCannotBeEmpty'))
        return
      }
      if (!('carrierId' in vessel) || StrUtils.isEmpty(vessel.carrierId)) {
        this.$message.warning(this.$t('SeaExport.MasterShippingCompanyCannotBeEmpty'))
        return
      }
      let checkUnique = false
      for (const gridVessel of this.vesselGrid.rowData) {
        if (!this.isAdd && vessel.uuid === gridVessel.uuid) { // 不为新增时、不与自己比较
          continue
        }
        if ((vessel.chineseName && vessel.chineseName === gridVessel.chineseName) || vessel.englishName === gridVessel.englishName) {
          checkUnique = true
          break
        }
      }
      if (checkUnique) {
        this.$confirm(this.$t('SeaExport.alreadyExistsShipNameAndContinueToSave'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => {
          this.saveVessel()
        }).catch(() => {
        })
      } else {
        this.saveVessel()
      }
    },
    saveVessel() {
      this.fullscreenLoading = getLoading()
      const vesselCarriers = []
      for (const carrier of this.carrierGrid.rowData) {
        if (carrier.dirty) {
          vesselCarriers.push(carrier)
        }
      }
      const { vessel, delCarrierRows, isAdd } = this
      const data = {
        vessel,
        delCarrierRows,
        isAdd,
        vesselCarriers
      }
      saveVessel(data).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.clearChoose()
        this.toQuery()
        this.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    downloadTemplate() {
      ExportUtils.downloadTemplateFile('ImportVesselTemplate.xls', 'partner')
    },
    importVesselResultLog() {
      this.fullscreenLoading = getLoading()
      queryLastFileDocumentId({ documentCategory: '100001', branchId: this.$store.getters.currentOfficeId }).then(res => {
        this.fullscreenLoading.close()
        const fileId = res.data
        if (fileId === '') {
          this.$message.warning(this.$t('SeaExport.NotFindFile'))
          return
        }
        const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
        window.open(url)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onEditCancel() {
      this.carrierGrid.gridOptions.api.clearFocusedCell()
      if (this.isEdit) {
        this.onCancel()
        return
      }
      this.onEdit()
    },
    onEdit() {
      if (!this.vesselGrid.selectedRow) {
        return
      }
      this.isEdit = true
    },
    onCancel() {
      this.isAdd = false
      this.isEdit = false
      if (this.vesselGrid.selectedIndex >= 0) {
        this.reloadCarrierGrid()
      }
    },
    reloadCarrierGrid() {
      this.delCarrierRows = []
      if (this.vesselGrid.selectedRow.hasOwnProperty('vesselCarriers')) {
        delete this.vesselGrid.selectedRow.vesselCarriers
      }
      this.vessel = this.vesselGrid.selectedRow
      // 重新加载船公司列表
      new Vessel(this.vessel).getVesselCarriers().then(data => {
        this.carrierGrid.rowData = data
      })
    },
    onRemove() {
      if (this.vesselGrid.selectedRow) {
        this.fullscreenLoading = getLoading()
        delVessel({ vesselUuid: this.vesselGrid.selectedRow.uuid }).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.clearChoose()
          this.toQuery()
          this.fullscreenLoading.close()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    onCarrierAdd() {
      const newCarrier = {
        vessel: this.isAdd ? '' : this.vesselGrid.selectedRow['uuid'],
        dirty: true
      }
      const index = this.carrierGrid.rowData.length
      this.carrierGrid.rowData.push(newCarrier)
      this.carrierGrid.gridOptions.api.setFocusedCell(index)
    },
    onCarrierRemove() {
      const { api, rowData } = this.carrierGrid.gridOptions
      const selectedRow = this.carrierGrid.selectedRow
      if (!selectedRow) {
        return
      }
      if (selectedRow.uuid) { // 删除数据缓存
        this.delCarrierRows.push(selectedRow.uuid)
      }
      rowData.splice(this.carrierGrid.selectedIndex, 1) // 删除第一行数据
      api.setRowData(rowData)
      const newRowData = []
      api.forEachNode(node => newRowData.push(node.data))
      this.carrierGrid.rowData = newRowData
      this.carrierGrid.selectedRow = null
      this.carrierGrid.gridOptions.api.setFocusedCell(-1)
    },
    toQuery() {
      this.vesselGrid.rowData = []
      this.fullscreenLoading = getLoading()
      getVesselList().then(res => {
        this.vesselGrid.rowData = res.data
        this.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onVesselGridRowClickedEvent(e) {
      if (this.isEdit) {
        this.vesselGrid.gridOptions.api.setFocusedCell(this.vesselGrid.selectedIndex)
        return
      }
      const data = e.data
      this.vesselGrid.selectedRow = data
      this.vesselGrid.selectedIndex = e.rowIndex
      this.vessel = data
      new Vessel(data).getVesselCarriers().then(data => {
        this.carrierGrid.rowData = data
      })
    },
    onCarrierGridRowClickedEvent(e) {
      if (!this.isEdit) {
        this.carrierGrid.gridOptions.api.setFocusedCell(-1)
        return
      }
      const data = e.data
      this.carrierGrid.selectedRow = data
      this.carrierGrid.selectedIndex = e.rowIndex
    },
    // 清除选中的数据
    clearChoose() {
      this.isEdit = false
      this.isAdd = false
      this.vesselGrid.selectedRow = null
      this.vesselGrid.selectedIndex = -1
      this.vessel = {}
      this.carrierGrid.rowData = []
      this.vesselGrid.gridOptions.api.setFocusedCell(-1)
      this.carrierGrid.selectedRow = null
      this.carrierGrid.selectedIndex = -1
      this.carrierGrid.gridOptions.api.setFocusedCell(-1)
    },
    uploadExcelSuccess(response, file, fileList) {
      this.$refs.upload.clearFiles()
      if (response && response.data) {
        if (response.data.hasOwnProperty('errorMsg')) {
          this.$message.error(response.data.errorMsg)
          return
        }
        this.importResultDialog.visible = true
        this.importResultDialog.result = response.data
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onCellChange(params) {
      const { node } = params
      if (params.oldValue !== params.newValue) {
        node.data.dirty = true
      }
    },
    continueImporting() {
      this.importResultDialog.visible = false
      this.$refs['vesselUpload'].$refs['upload-inner'].$refs.input.click()
    },
    fetchOrderRequirement() {
    },
    vesselImport() {
      this.mscImportDialog.visible = true
    },
    mscEdiExport() {
      this.ediPopup.visible = true
      this.$refs.ediPopup.init()
    },
    onEdiPopupClose() {
      this.ediPopup.visible = false
    },
    onEdiOfVesselClose() {
      this.ediOfVessel.visible = false
    },
    getEDI(data) {
      const params = {
        templateUuid: data.uuid,
        editStatus: 28
      }
      this.ediPopup.visible = false
      getVesselEDI(params).then(res => {
        if (res.data === null) {
          this.$message.warning(this.$t('SeaExport.NoImportEDI'))
          return
        }
        this.$nextTick(() => {
          this.ediOfVessel.visible = true
          this.$refs.ediOfVessel.init(res.data, data)
        })
      })
    },
    closeImportResultDialog() {
      this.importResultDialog.visible = false
      this.toQuery()
    }
  }
}
</script>

<style scoped>

</style>
